import { render, staticRenderFns } from "./editBtns_action.vue?vue&type=template&id=88f5aa40&scoped=true"
import script from "./editBtns_action.vue?vue&type=script&lang=js"
export * from "./editBtns_action.vue?vue&type=script&lang=js"
import style0 from "./editBtns_action.vue?vue&type=style&index=0&id=88f5aa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f5aa40",
  null
  
)

export default component.exports